<template lang="pug">
  #body(:class='{connected: isConnected, groupSelected: !isAllGroopsSelected}')
    template(v-if='ready')
      shared-object-viewer
      context-menu
      .wrapper
        header.public-main-header
          a.logo(@click="toggleSideBar")
            .publicBars
              i.fa.fa-bars.closed
              i.fa.fa-times.open
        header.main-header(:class="{searchOpen: searchOpen || searchText}")
          a.logo(@click="toggleSideBar", role='button')
            b 
              .letter 
                img(src='static/logo.png')
              .bars
                i.fa.fa-bars.closed
                i.fa.fa-times.open
          nav.navbar.navbar-static-top(role='navigation')
            header-user-dropdown
            header-group-selection
            header-search-form
        sidebar-menu
        answering-hover
        .content-wrapper
          search-helper
          router-view(v-if="(!isConnected && $route.meta && !$route.meta.needConnected) || groopsAreLoaded")
          .alert.alert-default(v-else) {{$t("home.groupsLoading")}}
          // select-members
      events-create-event-modal(:eventsBus='eventsBus')
      events-import-i-c-s-modal(:eventsBus='eventsBus')
      quick-chat-conversation
      key-shortcuts
      modal-account
      connection-modal
      shared-object-members
      new-group
      new-members
      vue-select-a-group-modal
    template(v-else)
      .home-waiting
    footer
      cookie-law(theme='dark-lime', :buttonText="$t('cookiesAlert.btn')")
        div(slot='message')
          | {{$t("cookiesAlert.text")}}

    link(href='//fonts.googleapis.com/css?family=Source+Sans+Pro' rel='stylesheet' type='text/css' async='')
    link(href="//fonts.googleapis.com/css?family=Lato:400,300,700'" rel='stylesheet' type='text/css' async='')
    link(href='https://unpkg.com/emoji.css/dist/emoji.min.css' rel='stylesheet')
</template>
<script>
import _ from 'lodash'
const screen = () => import(/* webpackChunkName: "screen" */ '@/assets/css/screen.sass')

import {mapGetters} from 'vuex'

import swal from 'sweetalert2'

import CookieLaw from 'vue-cookie-law'

import HeaderGroupSelection from './HeaderGroupSelection'
import HeaderUserDropdown from './HeaderUserDropdown'
import HeaderSearchForm from './HeaderSearchForm'
import SidebarMenu from './SidebarMenu'
import SearchHelper from './SearchHelper'

import SharedObjectViewer from '@/components/shared/SharedObjectViewer'
import VueObjectImg from '@/components/shared/VueObjectImg'
import AnsweringHover from '@/components/shared/AnsweringHover'

import QuickChatConversation from '@/components/Chat/QuickChatConversation'

import SelectMembers from '@/components/shared/SelectMembers/SelectMembers'
import ConnectionModal from '@/components/shared/Connection/ConnectionModal'

import SharedObjectMembers from '@/components/shared/SharedObjectMembers/SharedObjectMembers'

import eventsBus from '@/components/shared/EventsBus'

import ContextMenu from '@/components/shared/ContextMenu'

import ModalAccount from '@/components/Files/ModalAccount'
import NewGroup from '@/components/GroupManagement/NewGroup'
import NewMembers from '@/components/GroupManagement/NewMembers'
import VueSelectAGroupModal from '@/components/shared/SelectAGroupModal'

import EventsCreateEventModal from '@/components/Events/Events-CreateEventModal'
import EventsImportICSModal from '@/components/Events/Events-ImportICSModal'

import KeyShortcuts from '@/components/KeyShortcuts/keyshortcuts'

import Noty from '@/components/shared/Notify'

import $ from 'jquery'

export default {
  data () {
    return {
      eventsBus,
      ready: false
    }
  },
  components: {
    HeaderGroupSelection,
    HeaderSearchForm,
    VueObjectImg,
    SidebarMenu,
    HeaderUserDropdown,
    AnsweringHover,
    SharedObjectViewer,
    SearchHelper,
    EventsCreateEventModal,
    EventsImportICSModal,
    KeyShortcuts,
    CookieLaw,
    SelectMembers,
    ModalAccount,
    ConnectionModal,
    ContextMenu,
    NewGroup,
    NewMembers,
    QuickChatConversation,
    SharedObjectMembers,
    VueSelectAGroupModal
  },
  // beforeRouteEnter (to, from, next) {
  //   next(function (vm) {
  //     if (vm.isInitialized) {
  //       if (to.meta.needConnected && !vm.isConnected) {
  //         vm.$router.push({name: 'Welcome'})
  //       }
  //     }
  //   })
  // },
  // beforeRouteUpdate (to, from, next) {
  //   if (this.isInitialized && to.meta.needConnected && !this.isConnected) {
  //     this.$router.push({name: 'Welcome'})
  //   } else {
  //     next()
  //   }
  // },
  created () {
    screen()
  },
  mounted () {
    this.checkNeedConnection()
    if (!window.mapLoaded) {
      $.ajax({
        url: 'https://maps.googleapis.com/maps/api/js?key=AIzaSyD8tdyHmgKjBjKOrSyYPGhIIP1EJIJDQdw&language=fr',
        dataType: 'script',
        async: true
      })
    }
    window.mapLoaded = true
    $('body').on('click', '.main-sidebar li', function () {
      return $('#body').removeClass('showSidebar')
    })
    $('body').on('click', function (e) {
      var $t
      $t = $(e.target)
      if ($t.closest('.sidebar').length === 0 && $t.closest('.logo').length === 0 && $t.closest('header').length === 0) {
        return $('#body').removeClass('showSidebar')
      }
    })
    let that = this
    this.$synchronize.addSyncItem('onlineContacts', {
      callback: (data) => {
        that.$store.dispatch('chat/setOnlineContacts', data)
      },
      interval: 5000
    })
    let firstCall = true
    this.$synchronize.addSyncItem('chatUpdate', {
      parameters () {
        let oldFirstCall = firstCall
        firstCall = false
        return {
          firstCall: oldFirstCall
        }
      },
      callback: (data) => {
        for (let conv of data.conversations) {
          that.$store.dispatch('chat/getNewMessages', conv)
        }
        if (data.conf) {
          that.$store.dispatch('chat/setConfiguration', data.conf)
        }
      },
      interval: 5000
    })
    this.$synchronize.addSyncItem('newsUpdateCount', {
      parameters () {
        this.selectedGroopsId = that.selectedGroopsId
        return {
          group: this.selectedGroopsId,
          lastTime: that.afterTimeFor(that.selectedGroopsId)
        }
      },
      callback: (data) => {
        if (data.newsCount) {
          that.$synchronize.disableSyncItem('newsUpdateCount')
          that.$store.dispatch('news/setHasNew', {groupId: this.selectedGroopsId, status: true})
          this.$store.dispatch('toAnswer/refresh')
        }
      },
      interval: 10000
    })
    this.$synchronize.addSyncItem('conversationsUpdateCount', {
      parameters () {
        this.selectedGroopsId = that.selectedGroopsId
        return {
          group: this.selectedGroopsId,
          lastTime: that.afterTimeFor(that.selectedGroopsId)
        }
      },
      callback: (data) => {
        this.$store.dispatch('conversations/setConversationsUpdateCount', data.conversationsCount)
      },
      interval: 30000
    })
    this.$store.dispatch('toAnswer/refresh')
    this.$synchronize.callASAP('onlineContacts')
    this.$synchronize.callASAP('chatUpdate')
    this.$synchronize.callASAP('conversationsUpdateCount')
    this.setAppwire()
  },
  destroyed () {
    this.$synchronize.removeSyncItem('newsUpdateCount')
    this.$synchronize.removeSyncItem('onlineContacts')
    this.$synchronize.removeSyncItem('chatUpdate')
    this.setOffAppwire()
  },
  computed: {
    ...mapGetters('user', [
      'isConnected',
      'isInitialized',
      'user'
    ]),
    ...mapGetters('groops', [
      'isAllGroopsSelected',
      'groopsAreLoaded',
      'firstSelectedGroop',
      'selectedGroopsId',
      'getGroupWithId'
    ]),
    ...mapGetters('search', [
      'searchOpen',
      'searchText'
    ]),
    ...mapGetters('news', [
      'afterTimeFor'
    ])
  },
  methods: {
    toggleSideBar () {
      if ((!$('#body').hasClass('publicView') || $('#body').hasClass('showSidebar')) && $(window).width() >= 468) {
        if (this.isAllGroopsSelected) {
          this.$router.push({name: 'Events'})
        } else {
          this.$store.dispatch('groops/selectAllGroops')
        }
      } else {
        $('#body').toggleClass('showSidebar')
        if ($('#body').hasClass('showSidebar')) {
          this.$router.push({query: {m: 'menu'}})
        }
      }
    },
    checkNeedConnection () {
      this.ready = false
      if (!this.isInitialized) {
        return
      }
      if (this.$route.meta.needConnected && !this.isConnected) {
        if (this.$route.fullPath !== '/') {
          this.$router.push({name: 'NeedConnection', query: {nextUrl: this.$route.fullPath}})
        } else {
          this.$router.push({name: 'Welcome'})
        }
      } else {
        this.ready = true
      }
    },
    checkGroupId () {
      if ('groupId' in this.$route.params) {
        if (this.$route.params.groupId) {
          if (this.firstSelectedGroop && this.firstSelectedGroop.id === parseInt(this.$route.params.groupId)) {
            return
          }
          let group = this.getGroupWithId(this.$route.params.groupId)
          if (group) {
            this.$store.dispatch('groops/select', [group])
          } else {
            this.$router.replace({params: {groupId: null}, query: this.$route.query})
          }
        } else {
          this.$router.replace({params: {groupId: null}, query: this.$route.query})
          this.$store.dispatch('groops/selectAllGroops')
        }
      }
    },
    setOffAppwire () {
      if (this.user) {
        this.$appwire.off('user/' + this.user.id + '/' + this.user.appwireKey)
        this.$appwireEvents.$off()
      }
    },
    setAppwire (oldValue) {
      if (this.isConnected) {
        this.$appwire.on('user/' + this.user.id + '/' + this.user.appwireKey, (msg) => {
          console.log('appwire ' + ': user/' + this.user.id + '/' + this.user.appwireKey, msg)
          this.$appwireEvents.$emit(msg.category, msg)
        })
        this.$appwireEvents.$on('groups', (data) => {
          this.$store.dispatch('groops/reload', true)
          if (data.action === 'deleteMember' && data.uid === this.user.id) {
            Noty.info(this._i18n.t('notifications.adminDeletesYou', {group: data.group.name}), {
              timeout: 10000
            })
          }
        })
        this.$appwireEvents.$on('invitations', async (data) => {
          this.$store.dispatch('groops/reloadInvitations')
          if (data.action === 'confirmed') {
            await this.$store.dispatch('groops/reload', true)
            if (this.isConnected && data.uid === this.user.id) {
              const group = this.$store.getters['groops/getGroupWithId'](data.gid)
              swal({
                title: this._i18n.t('notifications.youAreAccepted.title', {group: group.name}),
                text: this._i18n.t('notifications.youAreAccepted.subtitle', {group: group.name}),
                type: 'success',
                showCancelButton: false
              })
            } else {
              const group = this.$store.getters['groops/getGroupWithId'](data.gid)
              Noty.info(this._i18n.t('notifications.newMemberInGroup', {group: group.name}), {
                closable: true,
                callbacks: {
                  onClick: () => {
                    this.$router.push({name: 'Members', params: {groupId: group.id}})
                  }
                }
              })
            }
          } else if (data.action === 'accepted' && data.uid !== this.user.id) {
            const group = this.$store.getters['groops/getGroupWithId'](data.gid)
            Noty.info(this._i18n.t('notifications.newMemberAcceptsInvitation', {group: group.name}), {
              closable: true,
              callbacks: {
                onClick: () => {
                  this.$router.push({name: 'Members', params: {groupId: group.id}})
                }
              }
            })
          } else if (data.action === 'invite' && data.uid === this.user.id) {
            Noty.info(this._i18n.t('notifications.youAreInvited', {group: data.group.name}), {
              closable: true,
              callbacks: {
                onClick: () => {
                  this.$router.push({name: 'Invitations'})
                }
              }
            })
          } else if (data.action === 'askConfirmInvitation' && data.uid !== this.user.id) {
            const group = this.$store.getters['groops/getGroupWithId'](data.gid)
            Noty.info(this._i18n.t('notifications.anUserAskToJoin', {group: group.name}), {
              closable: true,
              callbacks: {
                onClick: () => {
                  this.$router.push({name: 'Members', params: {groupId: group.id}})
                }
              }
            })
          } else if (data.action === 'refused' && data.uid === this.user.id) {
            Noty.info(this._i18n.t('notifications.adminDeclinesYourInvit', {group: data.group.name}))
          }
        })
        this.$appwire.onConnect(() => {
          console.log('Connection from HOME !')
        })
      } else if (oldValue) {
        this.$appwire.off('user/' + oldValue.id + '/' + oldValue.appwireKey)
      }
    }
  },
  watch: {
    isInitialized () {
      this.checkNeedConnection()
    },
    groopsAreLoaded () {
      this.checkGroupId()
    },
    $route (newRoute, oldRoute) {
      if (oldRoute.query.m === 'menu' && newRoute.query.m !== 'menu') {
        $('#body').removeClass('showSidebar')
      } else if (oldRoute.query.m !== 'menu' && newRoute.query.m === 'menu') {
        $('#body').addClass('showSidebar')
      }
      this.checkGroupId()
    },
    firstSelectedGroop (newValue, oldValue) {
      let params = _.clone(this.$route.params)
      if (this.firstSelectedGroop) {
        params.groupId = this.firstSelectedGroop.id
        this.$router.push({params: params, query: this.$route.query})
      } else {
        params.groupId = null
        this.$router.push({params: params, query: this.$route.query})
      }
    },
    selectedGroopsId () {
      this.$store.dispatch('conversations/setConversationsUpdateCount', 0)
      this.$synchronize.callASAP('conversationsUpdateCount')
    },
    user (newValue, oldValue) {
      this.setAppwire(oldValue)
    }
  }
}
</script>
<style lang="sass">
@import "../../assets/css/variables"
#body
  // overrided by screen.sass when loaded
  visibility: hidden
</style>



// WEBPACK FOOTER //
// Home.vue?7586f448